import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAnnouncements } from 'app/gears/announcements/actions/announcementsActions'
import Announcement from 'app/gears/announcements/components/Announcement'
import Announcements from 'app/gears/announcements/components/Announcements'

/**
 * Display a list of announcements so that the user can choose to view one, or if the URL is set to view a specific announcement, displays that one
 * 
 * @param {Promise} props.getAnnouncements thunk to fetch announcements
 * @param {Array} props.announcements the announcements (from redux)
 * @param {boolean}props.minMode whether the component is rendered in a mini-gear
 * @param {boolean} props.isSuccess whether the announcement fetching was a success
 * @param {string} props.maxAnnouncementsToDisplay
 * 
 * @author Alex Clary
 * @prettier
 */
const AnnouncementsGear = ({ getAnnouncements, announcements, minMode, match, isSuccess, maxAnnouncementsToDisplay }) => {
  useEffect(
    () => { 
      announcements.length === 0 && getAnnouncements() 
    },
    [getAnnouncements, announcements]
  )

  // The actively viewed announcement, if any
  const activeAnnouncement = match && announcements.find(a => a.id === parseInt(match.params.id))

  return <div className='announcements usa-grid'>
    {/* prettier-ignore */}
    {isSuccess
      ? activeAnnouncement
        ? <Announcement announcement={activeAnnouncement} />
        : <Announcements announcements={announcements} minMode={minMode} maxAnnouncementsToDisplay={maxAnnouncementsToDisplay}/>
      : 'Loading...' }
  </div>
}

const mapDispatchToProps = {
  getAnnouncements
}

const mapStateToProps = (state) => ({
  ...state.announcementsState
})

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsGear)